import React, { createContext, useState } from 'react'

export const AtalhosContext = createContext()

export const AtalhosProvider = ({ children }) => {
    const [atalhos, setAtalhos] = useState([])

    const criarAtalho = (atalho, funcao) => {
        setAtalhos([...atalhos, atalho])
        ativarAtalho(atalho, funcao)
    }

    const removerAtalho = (atalho) => {
        const atalhosAtualizados = atalhos.filter(a => a !== atalho)
        setAtalhos(atalhosAtualizados)
        desativarAtalho(atalho)
    }

    const ativarAtalho = (atalho, funcao) => {
        const handler = (event) => {
            if (event.altKey && event.key === atalho) {
                event.preventDefault()
                funcao()
            }
        }
        window.addEventListener('keydown', handler)
        return handler
    }

    const desativarAtalho = (atalho, handler) => {
        window.removeEventListener('keydown', handler)
    }

    const resetarAtalhoParaPadrao = (atalho) => {
        const handler = atalhos.find(a => a.atalho === atalho)?.handler
        if (handler) {
            desativarAtalho(atalho, handler)
            removerAtalho(atalho)
        }
    }

    const value = {
        criarAtalho,
        removerAtalho,
        resetarAtalhoParaPadrao
    }

    return (
        <AtalhosContext.Provider value={value}>
            {children}
        </AtalhosContext.Provider>
    )
}
